import { IPIMServiceConnector, PIMServiceConnector } from '@/modules/api/PimApiConnector';
import { ILoadCarrierService } from './ILoadCarrierService';
import { useLoadCarrierStore } from '@/modules/loadCarriers/store/useLoadCarrierStore';

export class LoadCarrierServiceImpl implements ILoadCarrierService {
  private readonly loadCarrierStore: typeof useLoadCarrierStore;
  private readonly pimSvc: IPIMServiceConnector;

  constructor(loadCarrierStore: typeof useLoadCarrierStore) {
    this.loadCarrierStore = loadCarrierStore;
    this.pimSvc = PIMServiceConnector.getInstance();
  }
  
  async loadLoadCarriers(): Promise<void> {
     const loadCarriers = await this.pimSvc.getAllLoadCarriers();
     this.loadCarrierStore.getState().allLoadCarriers.set(loadCarriers);
  }

}
